import { gql } from '@lcs/shared/api';

export const getDeviceDetail = gql`
   query GetDeviceDetail($id: UInt!) {
      device(id: $id) {
         deviceId
         deviceTypeId
         macAddress
         account {
            accountId
            name
            extensionsConnection {
               items {
                  phonesConnection {
                     items {
                        handsetIpei
                        phoneId
                        phoneType
                        extension {
                           number
                           name
                        }
                     }
                  }
               }
            }
         }
         serialNumber
         lastFirmwareReported
         lastProvisionedDate
         lastZtResponse
         ztStatus
         description
         notes
         phone {
            phoneType
            extension {
               number
               name
            }
            sipUsersConnection {
               items {
                  sipUserId
                  userName
                  isConnected
                  lastConnected
                  isHacked
                  userAgents
                  internalIps
                  externalIps
                  isFraud
                  phone {
                     phoneId
                     phoneType
                     extension {
                        extensionId
                        number
                        name
                     }
                     adminPassword
                     devicesConnection {
                        items {
                           deviceId
                           deviceTypeId
                           macAddress
                        }
                     }
                  }
               }
            }
         }
         baseStationHandsetsConnection {
            items {
               baseStationHandsetId
               phoneId
               deviceId
               sortId
               phone {
                  sipUsersConnection {
                     items {
                        userAgents
                        internalIps
                        externalIps
                     }
                  }
                  handsetIpei
                  extension {
                     extensionId
                     number
                     name
                     isArchived
                  }
               }
            }
         }
         createDate
         createUser {
            userId
            name
         }
         updateDate
         updateUser {
            userId
            name
         }
      }
   }
`;
